import * as Yup from 'yup';

export const TurkTelekomModalSchema = Yup.object().shape({
  phoneNumber: Yup.string().nullable().required(''),
  turkTelekomCode: Yup.string().nullable().required(''),
});

export const HopiModalSchema = Yup.object().shape({
  hopiCode: Yup.string().nullable().required(''),
});

export const KocAilemModalSchema = Yup.object().shape({
  number: Yup.string().nullable().required(''),
});

export const ZubizuSchema = Yup.object().shape({
  zubizuCode: Yup.string().nullable().required(''),
});
